/**
 * @Date: 2020-06-15 13:54
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import http from '../http'

// 收款平台分页查询
// export const receivePlatQueryPage = data => {
//   return http.request({
//     url: '/business/receivePlatQueryPage',
//     data,
//     method: 'post'
//   })
// }

// 收款平台列表查询
// export const receivePlatQueryList = data => {
//   return http.request({
//     url: '/business/receivePlatQueryList',
//     data,
//     method: 'post'
//   })
// }

// 收款平台禁启用
// export const receivePlatEnableDisable = data => {
//   return http.request({
//     url: '/business/receivePlatEnableDisable',
//     data,
//     method: 'post'
//   })
// }

// 收款平台更新
// export const receivePlatUpdate = data => {
//   return http.request({
//     url: '/business/receivePlatUpdate',
//     data,
//     method: 'post'
//   })
// }

// 收款银行分页查询
// export const receiveBankQueryPage = data => {
//   return http.request({
//     url: '/business/receiveBankQueryPage',
//     data,
//     method: 'post'
//   })
// }

// 收款银行列表查询
// export const receiveBankQueryList = data => {
//   return http.request({
//     url: '/business/receiveBankQueryList',
//     data,
//     method: 'post'
//   })
// }

// 收款银行号段分页查询
// export const receiveBankNumberQueryPage = data => {
//   return http.request({
//     url: 'business/receiveBankNumberQueryPage',
//     data,
//     method: 'post'
//   })
// }

// 收款银行号段更新
// export const receiveBankNumberUpdate = data => {
//   return http.request({
//     url: '/business/receiveBankNumberUpdate',
//     data,
//     method: 'post'
//   })
// }

// 收款银行号段导入
// export const receiveBankNumberImport = data => {
//   return http.request({
//     url: 'business/receiveBankNumberImport',
//     data,
//     method: 'post'
//   })
// }

// 收款银行新增
// export const receiveBankAdd = data => {
//   return http.request({
//     url: 'business/receiveBankAdd',
//     data,
//     method: 'post'
//   })
// }

// 收款平台地区新增
// export const receivePlatDetailAdd = data => {
//   return http.request({
//     url: 'business/receivePlatDetailAdd',
//     data,
//     method: 'post'
//   })
// }

// 收款平台新增
export const receivePlatAdd = data => {
  return http.request({
    url: 'business/receivePlatAdd',
    data,
    method: 'post'
  })
}

// 收款银行可用列表查询
// export const receiveBankAvailableQueryList = data => {
//   return http.request({
//     url: 'business/receiveBankAvailableQueryList',
//     data,
//     method: 'post'
//   })
// }

// 收款银行更新
// export const receiveBankUpdate = data => {
//   return http.request({
//     url: 'business/receiveBankUpdate',
//     data,
//     method: 'post'
//   })
// }

// 子账户银行新增
export const vaBankAdd = data => {
  return http.request({
    url: 'business/vaBankAdd',
    data,
    method: 'post'
  })
}

// 子账户银行可用列表查询
export const vaBankAvailableQueryList = data => {
  return http.request({
    url: 'business/vaBankAvailableQueryList',
    data,
    method: 'post'
  })
}

// 子账户银行分页查询
export const vaBankQueryPage = data => {
  return http.request({
    url: 'business/vaBankQueryPage',
    data,
    method: 'post'
  })
}

// 子账户银行更新
export const vaBankUpdate = data => {
  return http.request({
    url: 'business/vaBankUpdate',
    data,
    method: 'post'
  })
}
